import { apiFetch } from '../httpClient';

const TEAM_JOIN_REQUESTS_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_JOIN_REQUESTS_ENDPOINT_TEMPLATE || '/api/teams/:teamId/join-requests';
const TEAM_JOIN_REQUEST_APPROVE_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_JOIN_REQUEST_APPROVE_ENDPOINT_TEMPLATE ||
  '/api/teams/:teamId/join-requests/:joinRequestId/approve';
const TEAM_JOIN_REQUEST_REJECT_ENDPOINT_TEMPLATE =
  process.env.REACT_APP_TEAM_JOIN_REQUEST_REJECT_ENDPOINT_TEMPLATE ||
  '/api/teams/:teamId/join-requests/:joinRequestId/reject';

function buildPathFromTemplate(template, pathParams = {}) {
  return Object.entries(pathParams).reduce((path, [key, value]) => {
    return path
      .replace(`:${key}`, encodeURIComponent(String(value)))
      .replace(`{${key}}`, encodeURIComponent(String(value)));
  }, template);
}

// 팀 가입 신청 목록(대기/처리 포함)을 조회한다.
export async function fetchTeamJoinRequests({ teamId }) {
  return apiFetch(buildPathFromTemplate(TEAM_JOIN_REQUESTS_ENDPOINT_TEMPLATE, { teamId }), {
    method: 'GET',
  });
}

// 로그인 사용자가 특정 팀에 가입 신청을 보낸다.
export async function createTeamJoinRequest({ teamId, message }) {
  return apiFetch(buildPathFromTemplate(TEAM_JOIN_REQUESTS_ENDPOINT_TEMPLATE, { teamId }), {
    method: 'POST',
    body: {
      message: typeof message === 'string' ? message : '',
    },
  });
}

// 운영진/회장이 가입 신청을 승인한다.
export async function approveTeamJoinRequest({ teamId, joinRequestId }) {
  return apiFetch(
    buildPathFromTemplate(TEAM_JOIN_REQUEST_APPROVE_ENDPOINT_TEMPLATE, {
      teamId,
      joinRequestId,
    }),
    {
      method: 'POST',
    },
  );
}

// 운영진/회장이 가입 신청을 반려한다.
export async function rejectTeamJoinRequest({ teamId, joinRequestId }) {
  return apiFetch(
    buildPathFromTemplate(TEAM_JOIN_REQUEST_REJECT_ENDPOINT_TEMPLATE, {
      teamId,
      joinRequestId,
    }),
    {
      method: 'POST',
    },
  );
}
